/**
 * Devuelve el símbolo de la moneda para la localidad y el código de moneda especificados.
 *
 * @param {string} locale - La localidad a utilizar, por ejemplo, "es-ES" o "en-US".
 * @param {string} currency - El código de la moneda, por ejemplo, "USD" o "EUR".
 * @returns {string} - El símbolo de la moneda asociado a la localidad y al código de moneda.
 */
export const getCurrencySymbol = (locale, currency) => (
  (0).toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim()
);
